export const AFL_LISTING_TRACKER_ADDRESS = import.meta.env.PROD
  ? '0x8f9231920da9af6d'
  : '0x5c69057131939fe3'
